<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.99965 17.2499V20.9999H6.74965L17.8096 9.92989L14.0596 6.17989L2.99965 17.2499ZM22.6096 18.3599L18.3596 22.6099L13.1596 17.4099L14.9296 15.6399L15.9296 16.6399L18.3996 14.1599L19.8196 15.5799L18.3596 16.9999L19.4196 17.9999L20.8396 16.5999L22.6096 18.3599ZM6.60965 10.8299L1.38965 5.63989L5.63965 1.38989L7.39965 3.15989L4.92965 5.63989L5.99965 6.69989L8.45965 4.21989L9.87965 5.63989L8.45965 7.04989L9.45965 8.04989L6.60965 10.8299ZM20.7096 6.99989C21.0996 6.60989 21.0996 5.99989 20.7096 5.58989L18.3696 3.28989C17.9996 2.89989 17.3496 2.89989 16.9596 3.28989L15.1196 5.11989L18.8696 8.86989L20.7096 6.99989Z"
      fill="#6C6C7D" />
  </svg>
</template>

<script>
  export default {
    name: "PencilRulerIcon",
  };
</script>

<style></style>
